<template>
  <v-textarea
    class="media-list-notes-textarea"
    v-model="noteModel"
    :disabled="!$canControlNodeAndPod()"
    :messages="message"
    :error="error"
    @focus="focused"
    @blur="blurred"
    :hide-details="isDetailsHidden"
    flat
    variant="solo-filled"
    density="compact"
    rows="3"
    :label="$t('routes.node.note')"
    placeholder=" "
  />
</template>

<script>
import { useNodeStore } from '@/stores/NodeStore.js';

export default {
  name: "NodeItemNote",
  props: {
    node: {
      type: Object,
      required: true,
    },
    note: {
      type: String,
      required: false,
    }
  },
  data: function() {
    return {
      noteModel: "",
      originalValue: "",
      success: false,
      error: false,
      message: "",
    };
  },
  mounted: function() {
    this.noteModel = this.node.note || "";
    this.originalValue = this.node.note || "";
  },
  methods: {
    focused: function() {
      this.setNeutral();
      // Store the original value when user starts editing
      this.originalValue = this.noteModel;
    },
    async blurred() {
      const currentValue = (this.noteModel || "").trim();
      const originalValue = (this.originalValue || "").trim();

      // Only send request if there's an actual change
      if (currentValue === originalValue) {
        return;
      }

      if (this.noteModel && this.noteModel.length >= 4096) {
        this.setError(this.$t('menus.createNode.nodeNoteMaxLength'));
        return;
      }

      const payload = {
        id: this.node.id,
        note: this.noteModel,
      };

      const nodeStore = useNodeStore();

      try {
        await nodeStore.updateNote(payload);

        // Check if the component has been unmounted
        if (!this || !this.$t) {
          return;
        }
        // Update the original value after successful save
        this.originalValue = this.noteModel;
        this.setSuccess(this.$t('routes.node.notesUpdated'));
      } catch (error) {
        // Reset to original value on error
        this.noteModel = this.originalValue;
        if (error && error.response && error.response.data && error.response.data.error) {
          this.setError(error.response.data.error.message);
        } else {
          this.setError("Error!");
          console.log(error);   // unhandled error
        }
      }
    },
    setError: function(message) {
      this.success = false;
      this.error = true;
      this.$showMessage(message, { type: "error" });
    },
    setSuccess: function(message) {
      this.success = true;
      this.error = false;
      this.$showMessage(message, { type: "success" });
    },
    setNeutral: function() {
      this.success = false;
      this.error = false;
      this.message = "";
    }
  },
  computed: {
    isDetailsHidden: function() {
      if (this.message && this.message.length > 0) {
        return false;
      }

      return true;
    }
  },
  watch: {
    note: function(newValue, oldValue) {
      if (newValue != oldValue) {
        this.noteModel = newValue || "";
        this.originalValue = newValue || "";
      }
    },
    'node.note': function(newValue) {
      if (newValue !== this.noteModel) {
        this.noteModel = newValue || "";
        this.originalValue = newValue || "";
      }
    }
  }
}
</script>

<style>
/* Check the styles in PodItemNote */
</style>
